import { render, staticRenderFns } from "./ExternalDeliveryResults.vue?vue&type=template&id=3ca595be"
import script from "./ExternalDeliveryResults.vue?vue&type=script&lang=js"
export * from "./ExternalDeliveryResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports